export * from './juris-three-offers-switch-frequency-plan-card-paywall'
